<ng-container *transloco="let t" class="container">
  <div [ngClass]="cssClass ? cssClass : ''">
    @if (label || translatedLabel) {
    <label [for]="formId ? formId : formControlName">
      {{ translatedLabel || t(label!) }}
      @if(control.errors?.['required']){
      <ng-container>
        <small>*</small>
      </ng-container>
      }
    </label>
    }
    <div class="input-group">
      <input type="text" [name]="formControlName" [formControl]="control" [id]="formId ? formId : formControlName"
        class="form-control" [class.show-border-right]="!showCopyIcon"
        [placeholder]="translatedPlaceholder || placeholder ? t(placeholder!) : t(label!)">
      @if(showCopyIcon){
      <button class="btn btn-outline-secondary" type="button" (click)="onCopyIconClick()"
        [ngClass]="{'button-error': control.touched && !hideErrorMessage}">
        <i class="bi bi-clipboard fs-5" ngbTooltip="{{tooltipText ?? '-'}}" tooltipClass="ngb-tooltip-nowrap"></i>
      </button>
      }
    </div>
    @if (control.touched && !hideErrorMessage) {
    @for(errorMessage of control.errors | errorMessages:formControlName; track errorMessage){
    <div class="errorMes pt-1">
      {{ errorMessage }}
    </div>
    }
    }
  </div>
</ng-container>